export const locale = {
    lang: 'fr',
    data: {
        'AUTH': {
            'TITLE' : 'ACCÉDER À VOTRE COMPTE',
            'USERNAME': 'Login',
            'PASSWORD': 'Mot de passe',
            'LOGIN': 'CONNEXION',
            'USERNAME_REQUIRED': 'Login obligatoire',
            'PASSWORD_REQUIRED': 'Mot de passe obligatoire'
        }
    }
};